<template>
    <div class="grid">
        <div class="col-12">
            <div class="card" v-if="permission?.includes('read')">
                <ConfirmDialog />
                <Toast />
                <Error :errors="errors" />

                <Fieldset legend="Import" :toggleable="true" :collapsed="true" class="mb-3"
                    v-if="permission.includes('create')">
                    <Import @submit="getDataTable()" ref="import" />
                </Fieldset>

                <Fieldset legend="Import Status" :toggleable="true" :collapsed="true" class="mb-3"
                    v-if="permission.includes('create')">
                    <ImportStatus @submit="getDataTable()" ref="importStatus" />
                </Fieldset>

                <DataTable :value="dataTable" v-model:selection="selectedRows" :selectAll="selectAll"
                    @select-all-change="onSelectAllChange" responsiveLayout="scroll" :loading="loading" dataKey="number"
                    @sort="onSort($event)" :resizableColumns="true">
                    <template #header>
                        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <div>
                                <Button :loading="loadingExcel" label="Export Excel" icon="pi pi-file-excel"
                                    class="p-button p-button-success mr-2 my-1 inline-block"
                                    @click="exportExcelCSV('xlsx')" />
                                <Button :loading="loadingCsv" label="Export CSV" icon="pi pi-file-excel"
                                    class="p-button p-button-success mr-2 my-1 inline-block"
                                    @click="exportExcelCSV('csv')" />
                                <Button type="button" label="Update Status" icon="pi pi-angle-down"
                                    @click="toggleBulkMenu" aria-haspopup="true" aria-controls="overlay_menu"
                                    class="p-button p-button-info mr-2 my-1 inline-block" />
                                <Menu id="overlay_menu" ref="bulkMenu" :model="bulkMenuItems" :popup="true" />
                            </div>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="search" placeholder="Cari..." @keyup.enter="getDataTable" />
                            </span>
                        </div>
                    </template>
                    <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
                    <Column field="number" header="No." :style="{ width: '20px' }">
                        <template #body="slotProps">
                            {{ slotProps.data.number }}
                        </template>
                    </Column>
                    <Column field="salesman_type" header="Salesman Type">
                        <template #body="slotProps">
                            {{ slotProps.data.salesman_type }}
                        </template>
                    </Column>
                    <Column field="salesman_sdp_code" header="Salesman Sdp Code">
                        <template #body="slotProps">
                            {{ slotProps.data.salesman_sdp_code }}
                        </template>
                    </Column>
                    <Column field="salesman_code" header="Salesman Code">
                        <template #body="slotProps">
                            {{ slotProps.data.salesman_code }}
                        </template>
                    </Column>
                    <Column field="salesman_name" header="Salesman Name">
                        <template #body="slotProps">
                            {{ slotProps.data.salesman_name }}
                        </template>
                    </Column>
                    <Column field="region_name" header="Region">
                        <template #body="slotProps">
                            {{ slotProps.data.region_name }}
                        </template>
                    </Column>
                    <Column field="ship_to_code" header="Ship To Code">
                        <template #body="slotProps">
                            {{ slotProps.data.ship_to_code }}
                        </template>
                    </Column>
                    <Column field="distributor_name" header="Distributor">
                        <template #body="slotProps">
                            {{ slotProps.data.distributor_name }}
                        </template>
                    </Column>
                    <Column field="user_code" header="User Code">
                        <template #body="slotProps">
                            {{ slotProps.data.user_code }}
                        </template>
                    </Column>
                    <Column field="user_name" header="User Name">
                        <template #body="slotProps">
                            {{ slotProps.data.user_name }}
                        </template>
                    </Column>
                    <Column field="is_active" header="Status">
                        <template #body="slotProps">
                            <Button icon="pi pi-check" class="p-button-rounded p-button-success"
                                v-if="slotProps.data.is_active == 'y'" />
                            <Button icon="pi pi-times" class="p-button-rounded p-button-danger" v-else />
                        </template>
                    </Column>
                    <Column header="Aksi">
                        <template #body="slotProps">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2"
                                @click="editStatus(slotProps.data)" v-if="permission.includes('update')" />
                        </template>
                    </Column>

                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait. </template>
                    <template #footer>
                        In total there are {{ totalItemsCount ? totalItemsCount : 0 }} data.
                    </template>
                </DataTable>

                <Paginator v-model:rows="rows" v-model:first="offset" :totalRecords="totalItemsCount"
                    :rowsPerPageOptions="[10, 20, 30]">
                    <template>
                        {{ totalItemsCount }}
                    </template>
                </Paginator>

                <Dialog v-model:visible="editStatusDialog" :style="{ width: '450px' }" header="Data Detail"
                    :modal="true" class="p-fluid">

                    <div class="field">
                        <label>Status</label>
                        <Dropdown ref="dstatus" v-model="item.status_user" :options="dataDropdownStatus"
                            :class="{ 'p-invalid': errorEdit.status }" optionLabel="name" optionValue="code"
                            placeholder="Pilih Status" :showClear="true" />
                        <small class="p-invalid" style="color: red" v-if="errorEdit.status">{{ errorEdit.status[0]
                            }}</small>
                    </div>
                    <template #footer>
                        <Button label="Batal" icon="pi pi-times" class="p-button-text" @click="hideDialog" />
                        <Button label="Simpan" icon="pi pi-check" class="p-button-text" @click="updateStatus"
                            :loading="loadingEdit" />
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { numberingDatatable } from "../../utils/helpers";
import Error from "../../components/Error.vue";
import Import from "../../components/master/salesman/Import.vue";
import ImportStatus from "../../components/master/salesman/ImportStatus.vue";

export default {
    components: {
        Error: Error,
        Import: Import,
        ImportStatus: ImportStatus,
    },
    data() {
        return {
            // loading
            loading: false,
            loadingExcel: false,
            loadingCsv: false,

            // dataDropdown
            dataDropdownStatus: [
                { name: 'Aktif', code: 'y' },
                { name: 'Nonaktif', code: 'n' },
            ],

            // edit
            item: {},
            editStatusDialog: false,

            //datatables
            data: null,
            dataTable: null,
            selectedRows: null,
            selectAll: false,
            rows: 10,
            search: null,
            offset: null,
            field: null,
            sort: null,
            page: null,
            totalItemsCount: 0,
            bulkMenuItems: [
                {
                    label: 'Update Active',
                    icon: 'pi pi-check',
                    command: () => {
                        if (!this.selectedRows || this.selectedRows.length === 0) {
                            this.$toast.add({ severity: 'warn', summary: 'Peringatan', detail: 'Silakan centang data terlebih dahulu!', life: 3000 });
                            return;
                        }
                        this.$confirm.require({
                            message: 'Apakah Anda yakin ingin mengupdate status baris yang dicentang menjadi Aktif?',
                            header: 'Konfirmasi Update Status',
                            icon: 'pi pi-exclamation-triangle',
                            accept: () => {
                                this.updateBulkStatus('y');
                            }
                        });
                    }
                },
                {
                    label: 'Update Non Active',
                    icon: 'pi pi-times',
                    command: () => {
                        if (!this.selectedRows || this.selectedRows.length === 0) {
                            this.$toast.add({ severity: 'warn', summary: 'Peringatan', detail: 'Silakan centang data terlebih dahulu!', life: 3000 });
                            return;
                        }
                        this.$confirm.require({
                            message: 'Apakah Anda yakin ingin mengupdate status baris yang dicentang menjadi Nonaktif?',
                            header: 'Konfirmasi Update Status',
                            icon: 'pi pi-exclamation-triangle',
                            accept: () => {
                                this.updateBulkStatus('n');
                            }
                        });
                    }
                }
            ],
        };
    },
    mounted() {
        this.getDataTable();
        this.$store.commit("setErrors", {});
        this.$store.commit('setErrorEdit', {});
    },
    watch: {
        offset() {
            this.getDataTable();
        },
        rows() {
            this.getDataTable();
        },
    },
    computed: {
        ...mapGetters(["errors", "errorEdit"]),
        ...mapGetters("auth", ["permission"]),
    },
    methods: {
        formatDate(value) {
            if (value) {
                return moment.utc(value).format("DD-MM-YYYY");
            }
        },
        // EDIT
        editStatus(item) {
            this.item = item;
            this.item.status_user = item.is_active;

            this.editStatusDialog = true;
            this.$store.commit('setErrorEdit', {});

        },
        hideDialog() {
            this.editStatusDialog = false;
            this.submitted = false;
        },
        updateStatus() {
            this.loadingEdit = true;

            this.axios({
                method: 'POST',
                url: process.env.VUE_APP_ROOT_API + 'web/master-salesman/update-status',
                data: {
                    "salesman_id": this.item.salesman_id,
                    "status": this.item.status_user
                },
            })
                .then((res) => {
                    this.loadingEdit = false;
                    if (res) {
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: 'Data Berhasil Diupdate', life: 3000, });
                        this.$store.commit('setErrors', {});
                        this.$store.commit('setErrorEdit', {});
                        this.item = {};
                        this.editStatusDialog = false;
                        this.getDataTable();
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.loadingEdit = false;
                    this.$store.commit('setErrorEdit', err.response.data.data);
                    this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Data Gagal Diperbarui', life: 3000, });
                });
        },
        toggleBulkMenu(event) {
            this.$refs.bulkMenu.toggle(event);
        },
        updateBulkStatus(status) {
            if (!this.selectedRows || this.selectedRows.length === 0) {
                this.$toast.add({ severity: 'warn', summary: 'Warning', detail: 'Pilih data terlebih dahulu', life: 3000 });
                return;
            }

            this.loading = true;
            const salesmanIds = this.selectedRows.map(row => row.salesman_id);

            this.axios({
                method: 'POST',
                url: process.env.VUE_APP_ROOT_API + 'web/master-salesman/update-status-multiple',
                data: {
                    "salesman_id": salesmanIds,
                    "status": status,
                },
            })
                .then(() => {
                    this.$toast.add({ severity: 'success', summary: 'Successful', detail: 'Update Status Berhasil', life: 3000 });
                    this.selectedRows = [];
                    this.selectAll = false;
                    this.getDataTable();
                })
                .catch(err => {
                    console.log(err);
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Gagal melakukan Update', life: 3000 });
                    this.loading = false;
                });
        },
        // DATATABLE
        onSelectAllChange(event) {
            if (event.checked) {
                this.loading = true;
                this.axios({
                    method: "GET",
                    url: process.env.VUE_APP_ROOT_API + "web/master-salesman",
                    params: {
                        search: this.search,
                        per_page: this.totalItemsCount || 999999,
                        page: 1,
                        order_by: this.field,
                        sort_by: this.sort
                    },
                })
                    .then((res) => {
                        this.selectAll = true;
                        this.selectedRows = res.data.data.data;
                        this.selectedRows = numberingDatatable(
                            res.data.data.data,
                            1,
                            this.totalItemsCount
                        );
                        this.loading = false;
                    })
                    .catch((err) => {
                        console.log(err);
                        this.loading = false;
                    });
            } else {
                this.selectAll = false;
                this.selectedRows = [];
            }
        },
        getDataTable() {
            this.loading = true;

            this.page = this.offset / this.rows + 1;

            this.axios({
                method: "GET",
                url: process.env.VUE_APP_ROOT_API + "web/master-salesman",
                params: {
                    search: this.search,
                    per_page: this.rows,
                    page: this.page,
                    order_by: this.field,
                    sort_by: this.sort
                },
            })
                .then((res) => {
                    this.data = res.data.data.data;
                    this.dataTable = numberingDatatable(
                        res.data.data.data,
                        this.page,
                        this.rows
                    );
                    this.totalItemsCount = res.data.data.total;
                    this.rows = parseInt(res.data.data.per_page);
                    this.loading = false;

                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;

                });
        },
        onSort(event) {
            this.field = event.sortField;
            this.sort = event.sortOrder == "1" ? "ASC" : "DESC";
            this.getDataTable();
        },
        // EXPORT
        exportExcelCSV(ext) {
            if (ext == "xlsx") {
                this.loadingExcel = true;
            } else if (ext == "csv") {
                this.loadingCsv = true;
            }

            this.axios({
                method: "GET",
                url: process.env.VUE_APP_ROOT_API + "web/master-salesman/export",
                responseType: "blob",
                params: {
                    ext: ext,
                },
            })
                .then((response) => {
                    let fileUrl = window.URL.createObjectURL(response.data);
                    let fileLink = document.createElement("a");

                    fileLink.href = fileUrl;

                    fileLink.setAttribute("download", "Master Salesman Export." + ext);

                    document.body.appendChild(fileLink);

                    fileLink.click();

                    if (ext == "xlsx") {
                        this.loadingExcel = false;
                    } else if (ext == "csv") {
                        this.loadingCsv = false;
                    }
                })
                .catch((err) => {
                    console.log(err);

                    if (ext == "xlsx") {
                        this.loadingExcel = false;
                    } else if (ext == "csv") {
                        this.loadingCsv = false;
                    }
                });
        },
    },
};
</script>
